import { authHeader } from '../_helpers'
import axios from 'axios'

export const downloadService = {
  xlsx
}

async function xlsx () {
  return axios({
    url: process.env.ROOT_API + '/api/v1/exports',
    method: 'GET',
    headers: authHeader(),
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/_services/download.js